/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { priceType } from '@/context/pricetype';
import BaseServiceApi from './baseapi';

export interface productType{
    available: boolean;
    behavior: string;
    currency: string;
    expireDate: string;
    isTransform: boolean;
    newPrice: string;
    notice: string;
    origPrice: string;
    paymentType: string;
    priceId: string;
    productCode: priceType;
    productDesc: string;
    productId: number;
    productName: string;
    stdPrice: string;
    intervalCount:number;
    productStripeId:number;
    savingPercentage:number;
}

class StockApi {
  getProductprice(lang:string) {
    return BaseServiceApi.get<{plans:productType[], defaultCurrency:string}>('/api/v2/ch/pc/pl', { lang });
  }
}

const stockApi = new StockApi();

export default stockApi;
